/**
 * @generated SignedSource<<cd7f80518a45b652349a80c1e1751772>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ClientRequest, ClientQuery } from 'relay-runtime';
export type AdminPagesFieldsSidebarId = "ADDSCHEMES" | "COLUMNS" | "CREATE" | "EDIT" | "PROJECTS" | "SCHEMES" | "SCREENS";
export type useCurrentTab815BadPatternQuery$variables = Record<PropertyKey, never>;
export type useCurrentTab815BadPatternQuery$data = {
  readonly jira: {
    readonly centralizedFieldsAdminPage: {
      readonly currentSidebar: {
        readonly currentSidebarId: AdminPagesFieldsSidebarId | null | undefined;
      } | null | undefined;
    };
  } | null | undefined;
};
export type useCurrentTab815BadPatternQuery = {
  response: useCurrentTab815BadPatternQuery$data;
  variables: useCurrentTab815BadPatternQuery$variables;
};

const node: ClientRequest = (function(){
var v0 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "concreteType": "CentralizedFieldsAdminPage",
            "kind": "LinkedField",
            "name": "centralizedFieldsAdminPage",
            "plural": false,
            "selections": [
              {
                "concreteType": "AdminPagesFieldsSidebar",
                "kind": "LinkedField",
                "name": "currentSidebar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "currentSidebarId"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCurrentTab815BadPatternQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCurrentTab815BadPatternQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4d35f228b149b236d1d7338183485487",
    "id": null,
    "metadata": {},
    "name": "useCurrentTab815BadPatternQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c35e51931d8568cb5673215710db0ad0";

export default node;
